<template>
  <section class="split_wrapper">
    <div class="centered">
      <h1>404</h1>
      <h3>Page Not Found</h3>
      <p>We're sorry, the page you requested could not be found</p>
      
      
    </div>
  </section>
</template>

<script>
export default {
  methods: {
    getDefaultApp(){
      const _default_app = sessionStorage.getItem("_default_app");
      if(_default_app) return location.href = '/' + _default_app;
      return console.error("Default app is not configured for this user");
    },
  }
}
</script>


<style lang="scss" scoped>
.split_wrapper {
  background-color: var(--info);
  height: 100%;
  width: 100%;
  position: fixed;
  color: #fff;
  .icon {
    font-size: 70px;
    margin-bottom: 30px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-bottom: 100vh solid rgb(0 0 0 / 5%);
    border-left: 600px solid transparent;
    z-index: 2;
  }
  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-top: 100vh solid rgb(0 0 0 / 5%);
    border-left: 200px solid transparent;
    z-index: 2;
  }
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  transition: all ease-in-out 0.2s;
}
</style>
